import { FAILURE, SUCCESS } from "../../../../constants/BaseConstants";
import { call, put } from "redux-saga/effects";

import { GET_SCHOOLS_CATEGORIES } from "../../../../constants/SchoolConstants";
import getSchoolCategoriesCall from "../../../../api/SchoolCalls/getSchoolCategoriesCall";

export default function* getSchoolCategoriesSaga(): any {
    try {
        const categories = yield call(getSchoolCategoriesCall);
        yield put({ type: GET_SCHOOLS_CATEGORIES + SUCCESS, categories });
    } catch (error) {
        yield put({ type: GET_SCHOOLS_CATEGORIES + FAILURE, error });
    }
}
